import { Component, OnInit } from "@angular/core";
import { AppService } from "../../../services/app.service";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { Router} from "@angular/router";
import { NavController} from "@ionic/angular";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { BTN } from "../../../text_control/text_button";
import { TEXT as KEYTEXT } from "../../../text_control";
import { _deleteStorage, _getStorage, _setStorage } from "../../../utils/local-storage";
import { STORAGE } from "../../../constant/storages";
import { ROUTE } from "../../../constant/routes";
@Component({
  selector: "app-tax-invoice-select",
  templateUrl: "./tax-invoice-select.component.html",
  styleUrls: ["./tax-invoice-select.component.scss"],
})
export class TaxInvoiceSelectComponent implements OnInit {
  actice = 2;
  datasearch: any = [];
  checkdata: number;
  s = [];
  showadd = false;
  showtable = false;
  address: any;
  phone: any = "";
  taxid: any = "";
  company_name = "";
  pager: any = {};
  pagedItems = [];
  count: any;
  tbText: any;
  keyText: any;
  textBTN: any;

  constructor(
    public apiservice: ApiserviceService,
    public appService: AppService,
    public route: Router,
    public navCtrl: NavController,
  ) {
    this.tbText = TEXT_TABLE
    this.keyText = KEYTEXT;
    this.textBTN = BTN;
  }
  ngOnInit() { }

  ionViewDidEnter() {
    _deleteStorage(STORAGE.DATA_EDIT);
    this.datasearch = _getStorage(STORAGE.DATA_SELECTTAXINVOICE);
    if (this.datasearch) {
      this.s = this.datasearch;
      if (this.s.length > 0) {
        this.setPage(1);
        this.showadd = false;
        this.showtable = true;
      } else {
        this.showadd = true;
        this.showtable = false;
      }
    }
  }
 
  showcopy(data: any) {
    if (data.buyer_type === "0") {
      return false;
    } else if (data.buyer_type === "1") {
      return true;
    } else if (data.buyer_type === "2") {
      return false;
    }
  }

  gotoTaxInvoiceEdit(data: any) {
    _setStorage(STORAGE.DATA_EDIT, data)
    this.route.navigate([ROUTE.TAXINVOICE_EDIT]);
  }

  gotoTaxInvoiceSavedata() {
    this.route.navigate([ROUTE.TAXINVOICE_SAVEDATA]);
  }

  copy(data) {
    _setStorage(STORAGE.DATA_CREATEFULLTAX, data)
    this.route.navigate([ROUTE.TAXINVOICE_SAVEDATA]);
  }

  gototaxinvoicepreview(data: any) {
    _setStorage(STORAGE.DATA_ABB, data)
    this.route.navigate([ROUTE.TAXINVOICE_PREVIEW]);
  }

  gototaxinvoicesearchbuy(data: any) {
    _setStorage(STORAGE.DATA_ABB, data)
    this.route.navigate([ROUTE.TAXINVOICE_SEARCH_ABB]);
  }
  gototaxinvoice() {
    this.route.navigate([ROUTE.TAXINVOICE]);
  }

  checkbranch(data: any) {
    if (data.buyer_type === "0") {
      return "-";
    } else if (data.buyer_type === "1") {
      if (data.buyer_main_branch_no === "00000") {
        return "สำนักงานใหญ่";
      } else {
        return data.buyer_branch_no;
      }
    } else if (data.buyer_type === "2") {
      return "-";
    }
  }

  checkaddress(item) {
    if (item.type_addr === "1") {
      return item.addr_info;
    } else if (item.type_addr === "2") {
      return item.addr_infoEN;

    }
  }

  setPage(page: number) {
    this.pager = this.appService.getPager(this.datasearch.length, page);
    this.pagedItems = this.datasearch.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
